import DataTable from "react-data-table-component";

const DataTableComponent = ({ columns, data }) => {

  return (
    <>
      <DataTable columns={columns} data={data} pagination  />
    </>
  );
};

export default DataTableComponent;
